import { type Icon } from "@phosphor-icons/react";
import clsx from "clsx";

import { Fork } from "~/components/Fork";

export const ForkPrimary: React.FC<
  {
    title: string;
    description: string;
    icon: Icon;
  } & React.ComponentProps<"button">
> = ({ icon: Icon, title, description, className, ...props }) => {
  return (
    <Fork className={clsx("group/fork space-y-3 p-6", className)} {...props}>
      <Icon weight="duotone" className="mx-auto size-12" />
      <div className="space-y-1.5 text-base-content group-disabled/fork:text-current">
        <div className="text-xl leading-tight title">{title}</div>
        <div>{description}</div>
      </div>
    </Fork>
  );
};
